module.exports = __webpack_public_path__ + "img/pr-37.947f0e50.png";